module.exports = __webpack_public_path__ + "static/media/Hindi音読.d64aa920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Hindi音読.png
// module id = 288
// module chunks = 0